import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-d1932820")

_pushScopeId("data-v-d1932820")
const _hoisted_1 = {
  key: 0,
  class: "social-share-object-container"
}
const _hoisted_2 = {
  key: 1,
  class: "holder"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "34",
  height: "34",
  viewBox: "0 0 24 24",
  class: "icon-color"
}, [
  /*#__PURE__*/_createVNode("path", {
    d: "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z",
    class: "icon-color"
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "34",
  height: "34",
  viewBox: "0 0 24 24",
  class: "icon-color"
}, [
  /*#__PURE__*/_createVNode("path", {
    d: "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z",
    class: "icon-color"
  })
], -1)
const _hoisted_5 = {
  class: "slider",
  ref: "scrollContainer"
}
const _hoisted_6 = {
  class: "moment-holder",
  id: "parmonic-moments"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SocialShare = _resolveComponent("SocialShare")
  const _component_VideoPlayer = _resolveComponent("VideoPlayer")
  const _component_IframeVideoPlayer = _resolveComponent("IframeVideoPlayer")
  const _component_HorizontalOption = _resolveComponent("HorizontalOption")

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.isAnySocialMediaButtonEnable)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          (_ctx.optionsObj.currentSelection.value.id != -1)
            ? (_openBlock(), _createBlock(_component_SocialShare, {
                key: 0,
                id: _ctx.optionsObj.currentSelection.value.id,
                title: _ctx.translateMoment(_ctx.optionsObj.currentSelection.value).title,
                description: _ctx.translateMoment(_ctx.optionsObj.currentSelection.value).description,
                share_buttons: _ctx.webinarInfo.share_buttons
              }, null, 8, ["id", "title", "description", "share_buttons"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock("div", {
      id: "slider-player",
      class: "rnd-crns",
      key: _ctx.optionsObj.currentSelection.value.id
    }, [
      (
          !_ctx.optionsObj.currentSelection.value.video_urls.iframe_url ||
          _ctx.optionsObj.currentSelection.value.video_urls.iframe_url == ''
        )
        ? (_openBlock(), _createBlock(_component_VideoPlayer, {
            key: 0,
            mid: _ctx.optionsObj.currentSelection.value.id,
            poster: _ctx.optionsObj.currentSelection.value.video_urls.poster_url,
            video_urls: _ctx.optionsObj.currentSelection.value.video_urls,
            subtitleUrls: _ctx.optionsObj.currentSelection.value.subtitle_urls,
            subtitles: _ctx.optionsObj.currentSelection.value.subtitles,
            continuefromTime: _ctx.optionsObj.currentSelection.value.end_time,
            duration: _ctx.optionsObj.currentSelection.value.duration,
            videoType: _ctx.optionsObj.currentSelection.value.id == -1 ? _ctx.ContentType.Webinar : _ctx.ContentType.Moment,
            title: _ctx.translateMoment(_ctx.optionsObj.currentSelection.value).title,
            useDemoOverlay: _ctx.webinarInfo.use_demo_overlay,
            height: _ctx.height,
            logoOverlay: _ctx.webinarInfo.overlay_logo,
            isgated: _ctx.webinarInfo.is_gated,
            ma: _ctx.webinarInfo.ma,
            cta: _ctx.webinarInfo.cta,
            usetheaterMode: _ctx.usetheaterMode,
            post_play: _ctx.webinarInfo.post_play,
            autoPlay: _ctx.autoPlay,
            class: "full-video-player"
          }, null, 8, ["mid", "poster", "video_urls", "subtitleUrls", "subtitles", "continuefromTime", "duration", "videoType", "title", "useDemoOverlay", "height", "logoOverlay", "isgated", "ma", "cta", "usetheaterMode", "post_play", "autoPlay"]))
        : (_openBlock(), _createBlock(_component_IframeVideoPlayer, {
            key: 1,
            iframe_url: _ctx.optionsObj.currentSelection.value.video_urls.iframe_url,
            poster: _ctx.optionsObj.currentSelection.value.video_urls.poster_url,
            duration: _ctx.optionsObj.currentSelection.value.duration
          }, null, 8, ["iframe_url", "poster", "duration"]))
    ])),
    (_ctx.webinarInfo.moments.length > 1)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          (
          _ctx.arrowStatusService.arrowStatus.value.horizontalScroll &&
          !_ctx.arrowStatusService.arrowStatus.value.horizontalScrollAtLeft
        )
            ? (_openBlock(), _createBlock("div", {
                key: 0,
                class: "left btn",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.scrollLeft()))
              }, [
                _hoisted_3
              ]))
            : _createCommentVNode("", true),
          (
          _ctx.arrowStatusService.arrowStatus.value.horizontalScroll &&
          !_ctx.arrowStatusService.arrowStatus.value.horizontalScrollAtRight
        )
            ? (_openBlock(), _createBlock("div", {
                key: 1,
                class: "right btn",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.scrollRight()))
              }, [
                _hoisted_4
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.optionsObj.options, (m, i) => {
                return (_openBlock(), _createBlock(_component_HorizontalOption, {
                  id: 'moment-' + m.id,
                  key: i,
                  poster_url: m.video_urls.poster_url,
                  title: _ctx.translateMoment(m).title,
                  description: _ctx.translateMoment(m).description,
                  isSelected: m.id == _ctx.optionsObj.currentSelection.value.id,
                  duration: _ctx.formatDate(m.duration),
                  onClick: ($event: any) => (_ctx.changeSelection(m.id)),
                  isWebinar: m.id == -1
                }, null, 8, ["id", "poster_url", "title", "description", "isSelected", "duration", "onClick", "isWebinar"]))
              }), 128))
            ])
          ], 512)
        ]))
      : _createCommentVNode("", true)
  ]))
})